import {
  InitClient,
  GetByParas,
  Post,
  PostWithParas,
  PostNoParas
} from "../ZeusAPIClient.js";
import { apiConfig } from "../../config.js";
import { PagingBody } from "../Model/PagingBody";
import { Predicate } from "../Model/Predicate";

InitClient(apiConfig.clientId, apiConfig.clientSecret, apiConfig.host);

//大盘绩效模板列表
async function BigKPITemplate(periodType, p, pageSize, title) {
  var data = {
    types: periodType, //类型   0大盘绩效模板  1绩效模板
    p: p, //当前页
    pageSize: pageSize, //页大小
    title: title //KPI名称
  };
  return await PostWithParas("ea874847-8113-4bed-8bd3-b153f356ca4a", {}, data);
}

//获取大盘绩效详情
async function GetBigKPITemplate(id) {
  var paras = {
    id: id
  };
  return await PostWithParas("053e69f3-2ced-466d-9630-b26e9655c6cc", paras, {});
}

//添加/编辑大盘绩效模板
async function BigKPITemplateSave(data) {
  return await PostWithParas("91b352c3-ab0c-446c-adda-352088a01e2d", {}, data);
}

//删除大盘绩效模板
async function DelBigKPITemplate(userCode, id) {
  var paras = {
    userCode: userCode
  };
  return await PostWithParas("23b2df11-c272-43cb-9d27-6fe9a86ff49b", paras, id);
}

//生成大盘绩效
async function AddBigKPITemplateRelation(PeriodType, userCode) {
  var paras = {
    PeriodType: PeriodType,
    userCode: userCode
  };
  return await PostWithParas("a7e4c6d2-55d2-44ed-9563-d9340ccf7fc9", paras, {});
}

//大盘对应关系列表
async function BigKPITemplateRelation(id, pageIndex, pageSize) {
  var data = {
    p: pageIndex,
    pageSize: pageSize,
    kpiTid: id
  };
  return await PostWithParas("332e9dcc-0bdf-40f9-b761-8381a6efe301", {}, data);
}

//获取大盘对应关系详情
async function GetBigKPITemplateRelation(id) {
  var paras = {
    id: id
  };
  return await PostWithParas("b34b7dfe-a5a4-4410-a3f8-1629aa0112b3", paras, {});
}

//添加/编辑对应关系
async function BigKPITemplateRelationSave(data) {
  return await PostWithParas("ec5c732c-2f17-47ae-87ff-89ac50564897", {}, data);
}

//删除对应关系
async function DelBigKPITemplateRelation(userCode, id) {
  var paras = {
    userCode: userCode
  };

  return await PostWithParas("1a0fee98-cb5e-448f-b912-1ce8ddddcd98", paras, id);
}

//额外从属关系列表
async function ExtrasRelation(pageIndex, pageSize, name) {
  var data = {
    p: pageIndex,
    pageSize: pageSize,
    name: name
  };
  return await PostWithParas("397b12bc-4ae5-42ee-bf90-e29ddade08cf", {}, data);
}

//添加/编辑从属关系
async function ExtrasRelationSave(ExtrasModel) {
  return await PostWithParas(
    "898202d4-796f-470f-ab11-0bc4ca0556f0",
    {},
    ExtrasModel
  );
}

//获取从属关系详情
async function GetExtrasRelation(id) {
  var paras = {
    id: id
  };
  return await PostWithParas("1d5a41c2-d71a-450c-a14b-67ee6031e523", paras, {});
}

//删除从属关系
async function DelExtrasRelation(userCode, id) {
  var paras = {
    userCode: userCode
  };
  return await PostWithParas("3dd76462-8626-4fc1-a497-c540a93f952d", paras, id);
}

//获取指标名称列表
async function GetQuotanameList(pid, p, pageSize, title) {
  var paras = {
    pid: pid,
    p: p,
    pageSize: pageSize,
    title: title
  };
  return await PostWithParas("e567b04d-137e-400c-8fab-f9d62c9c8f6d", {}, paras);
}

// 添加/编辑单个指标
async function EditSingleQuota(data) {
  return await PostWithParas("e5bc9b0b-c07b-48f9-807b-4d2231206b2d", {}, data);
}

// 删除单个指标
async function DeleteSingleQuota(userCode, id) {
  var paras = {
    userCode: userCode
  };
  return await PostWithParas("20d66aac-fd5a-4148-82d6-e0be400de83b", paras, id);
}
// 获取不检测列表
async function GetnoDetection(p, pageSize, exType) {
  var paras = {
    p: p,
    pageSize: pageSize,
    exType: exType
  };
  return await PostWithParas("18429f48-27b3-40c8-a870-1bd03902d0a9", {}, paras);
}

// 添加/编辑单个不检测
async function EditSingleNoDetection(data) {
  return await PostWithParas("fdb779a3-180b-49e7-8d3b-b60f30b5f1a3", {}, data);
}

// 删除单个不检测
async function DeleteSingleNoDetection(userCode, id) {
  var paras = {
    userCode: userCode
  };
  return await PostWithParas("6bd26a50-d4af-486e-854b-69b62c6016af", paras, id);
}
// 测试接口
async function testApi(userCode, id) {
  var paras = {
    userCode: userCode
  };
  return await PostWithParas("6bd26a50-d4af-486e-854b-69b62c6016af", paras, id);
}

export {
  BigKPITemplate,
  BigKPITemplateSave,
  GetBigKPITemplate,
  DelBigKPITemplate,
  AddBigKPITemplateRelation,
  BigKPITemplateRelation,
  GetBigKPITemplateRelation,
  BigKPITemplateRelationSave,
  DelBigKPITemplateRelation,
  ExtrasRelation,
  ExtrasRelationSave,
  GetExtrasRelation,
  DelExtrasRelation,
  GetQuotanameList,
  EditSingleQuota,
  DeleteSingleQuota,
  GetnoDetection,
  EditSingleNoDetection,
  DeleteSingleNoDetection
};
